import type { MagneticWallType } from '../../editor/editorSlice';
import { getAnnotationIdFromUrlHash } from '../../utils/url/annotationThreadHash';
import { getThreadIdFromUrlHash } from '../../utils/url/commentThreadHash';
import { getReactionIdFromUrlHash } from '../../utils/url/reactionThreadHash';

function parseMagneticWallHash(
  hash: string,
): { type: MagneticWallType; id: string } | null {
  const threadId = getThreadIdFromUrlHash(hash);
  if (threadId) {
    return { type: 'comment', id: threadId };
  }

  const annotationId = getAnnotationIdFromUrlHash(hash);
  if (annotationId) {
    return { type: 'annotation', id: annotationId };
  }

  const reactionId = getReactionIdFromUrlHash(hash);
  if (reactionId) {
    return { type: 'reaction', id: reactionId };
  }

  return null;
}

export default parseMagneticWallHash;
